import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { WIDE_PAGE_WIDTH } from '../Page';

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  max-width: ${WIDE_PAGE_WIDTH}px;
  margin: 0 auto;
  padding: calc(var(--top-clear) + 10px) 16px 0;
`;

export const Logo = styled.img`
  display: block;
  height: 44px;
  width: auto;
`;

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 16px;

  a {
    color: var(--accent);
    font-weight: 600;
  }
`;

export const Home = styled(Link)`
  position: relative;
  display: block;
`;

/** How many games have moves you haven't seen, on the logo's corner. */
export const NewMovesDot = styled.span`
  position: absolute;
  top: -4px;
  right: -10px;
  min-width: 20px;
  height: 20px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--accent);
  color: var(--felt-deep);
  font-size: 12px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, .4);
`;
